// jQuery
$(function () {
  $(window).on('scroll', function () {
    var check = window.scrollY,
      docHeight = $(document).height(),
      dispHeight = $(window).height(),
      footerHeight = $('.footer').innerHeight();

    // $(".header").css("left", -$(window).scrollLeft());

    // if ($('.fv').height() < $(this).scrollTop()) {
    if ($(this).scrollTop() > 0) {
      $('.header').addClass('start');
    } else {
      $('.header').removeClass('start');
    }

    if (check > docHeight - dispHeight - footerHeight) {
      $('.update').fadeOut(600);
    } else {
      $('.update').fadeIn(600);
    }
  });

  $('.menu').hover(
    function () {
      $(this).find('.child, .child__overlay').css({ visibility: 'visible', opacity: 1 });
    },
    function () {
      $(this).find('.child, .child__overlay').css({ visibility: 'hidden', opacity: 0 });
    }
  );
  $('.child__overlay').hover(function () {
    $(this).siblings('.child').addBack().css({ visibility: 'hidden', opacity: 0 });
  });

  $('.burger').on('click', function () {
    $('.header').toggleClass('burger-open');
    var isOpen = $('.header').hasClass('burger-open');

    if (isOpen) {
      var scrollpos = $(window).scrollTop();
      $('body').addClass('fixed').css('top', -scrollpos);
      $('.burger__overlay').fadeIn();
    } else {
      $('.burger__overlay').fadeOut();
      var scrollpos = parseInt($('body').css('top'));
      $('body').removeClass('fixed').css('top', 0);
      window.scrollTo(0, -scrollpos);
    }
  });

  $('.burger__overlay').on('click', function () {
    $('.header').removeClass('burger-open');
    var scrollpos = parseInt($('body').css('top'));
    $('body').removeClass('fixed').css('top', 0);
    window.scrollTo(0, -scrollpos);
    $(this).fadeOut();
  });

  // TOPへ戻る
  var top = $('#top');
  top.click(function () {
    $('body, html').animate({ scrollTop: 0 }, 500);
    return false;
  });

  $('select').on('change', function () {
    if ($(this).val() == 'placeholder') {
      $(this).css('color', '#c0c1c1');
    } else {
      $(this).css('color', '#000');
    }
  });

  // 送信ボタンコントロール
  $('.btn button').prop('disabled', true);

  //入力欄の操作時
  $('.consent').change(function () {
    var flag = true;

    $('.consent').each(function (e) {
      if ($('.consent').eq(e).val() === '') {
        flag = false;
      }
    });

    if (flag && $('.consent').is(':checked')) {
      $('.btn button').prop('disabled', false);
    } else {
      $('.btn button').prop('disabled', true);
    }
  });

  // 絞り込み検索
  var search = '.narrow-down__btn', // 絞り込む項目を選択するエリア
    item = '.narrow-down__item', // 絞り込み対象のアイテム
    hide = 'hide'; // 絞り込み対象外の場合に付与されるclass名

  $(function () {
    // 絞り込み項目を変更した時
    $(document).on('change', search + ' input', function () {
      search_filter();
    });
  });

  // リストの絞り込みを行う
  function search_filter() {
    // 非表示状態を解除
    $(item).removeClass(hide);
    for (var i = 0; i < $(search).length; i++) {
      var name = $(search).eq(i).find('input').attr('name');
      // 選択されている項目を取得
      var searchData = get_selected_input_items(name);
      // 選択されている項目がない、またはALLを選択している場合は飛ばす
      if (searchData.length === 0 || searchData[0] === '') {
        continue;
      }
      // リスト内の各アイテムをチェック
      for (var j = 0; j < $(item).length; j++) {
        // アイテムに設定している項目を取得
        var itemData = get_setting_values_in_item($(item).eq(j), name);
        // 絞り込み対象かどうかを調べる
        var check = array_match_check(itemData, searchData);
        if (!check) {
          $(item).eq(j).addClass(hide);
        }
      }
    }
  }

  /**
   * inputで選択されている値の一覧を取得する
   * @param  {String} name 対象にするinputのname属性の値
   * @return {Array}       選択されているinputのvalue属性の値
   */
  function get_selected_input_items(name) {
    var searchData = [];
    $('[name=' + name + ']:checked').each(function () {
      searchData.push($(this).val());
    });
    return searchData;
  }

  /**
   * リスト内のアイテムに設定している値の一覧を取得する
   * @param  {Object} target 対象にするアイテムのjQueryオブジェクト
   * @param  {String} data   対象にするアイテムのdata属性の名前
   * @return {Array}         対象にするアイテムのdata属性の値
   */
  function get_setting_values_in_item(target, data) {
    var itemData = target.data(data);
    if (!Array.isArray(itemData)) {
      itemData = [itemData];
    }
    return itemData;
  }

  /**
   * 2つの配列内で一致する文字列があるかどうかを調べる
   * @param  {Array} arr1 調べる配列1
   * @param  {Array} arr2 調べる配列2
   * @return {Boolean}    一致する値があるかどうか
   */
  function array_match_check(arr1, arr2) {
    // 絞り込み対象かどうかを調べる
    var arrCheck = false;
    for (var i = 0; i < arr1.length; i++) {
      if (arr2.indexOf(arr1[i]) >= 0) {
        arrCheck = true;
        break;
      }
    }
    return arrCheck;
  }
});

// javascript
const ANIMATION_TIME = 600;
const OFFSET_TIME = 5;

document.addEventListener('DOMContentLoaded', function () {
  const accordions = document.querySelectorAll('.toggle details');
  accordions.forEach((accordion) => {
    const title = accordion.querySelector('.toggle summary');
    title.addEventListener('click', (e) => {
      e.preventDefault();
      if (!accordion.open) {
        accordion.open = true;
        setTimeout(() => {
          accordion.classList.add('is-opened');
        }, OFFSET_TIME);
        //
      } else if (accordion.open) {
        accordion.classList.remove('is-opened');
        setTimeout(() => {
          accordion.open = false;
        }, ANIMATION_TIME + OFFSET_TIME);
      }
    });

    accordion.addEventListener('toggle', () => {
      const hasOpenedClass = accordion.classList.contains('is-opened');

      if (accordion.open && !hasOpenedClass) {
        accordion.classList.add('is-opened');
      } else if (!accordion.open && hasOpenedClass) {
        accordion.classList.remove('is-opened');
      }
    });
  });
});
